// React i hooks
import { NavLink } from "react-router-dom";
import { memo } from "react";

// Helpers
import { classNames, transformRoute } from "helpers";

// Moduli specifični za projekt
import { Routes as SettingRoutes } from "ui/modules/navigation";

// Tipovi i konstante
import { TabMenuProps } from "./types";

const linkClassName = ({ isActive }: { isActive: boolean }) =>
  classNames(
    isActive
      ? "text-sky-600 border-b-2 border-b-sky-600"
      : "text-gray-600",
    "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
  );

const TabMenu: React.FC<TabMenuProps> = (props) => {
  const { tenantId } = props;

  return (
    <div className="flex border-b border-slate-200 bg-white">
      <NavLink
        end
        to={transformRoute(SettingRoutes.TenantDetailPageRouter, { tenantId })}
        className={linkClassName}
      >
        Osnovne informacije
      </NavLink>
     
      <NavLink
        to={transformRoute(SettingRoutes.TenantSubscriptionPageRouter, {
          tenantId,
        })}
        className={linkClassName}
      >
        Obračun pretplate
      </NavLink>
      <NavLink
        to={transformRoute(SettingRoutes.TenantUsersPageRouter, {
          tenantId,
        })}
        className={linkClassName}
      >
        Korisnici
      </NavLink>
      <NavLink
        to={transformRoute(SettingRoutes.TenantInvoicesPageRouter, {
          tenantId,
        })}
        className={linkClassName}
      >
        Izlazni računi
      </NavLink>
      <NavLink
        to={transformRoute(SettingRoutes.TenantActivitiesPageRouter, {
          tenantId,
        })}
        className={linkClassName}
      >
        Aktivnosti
      </NavLink>
    </div>
  );
};

export default memo(TabMenu);
